import React from "react";
import PropTypes from 'prop-types';
import EventContainer from "../containers/event_container"
import { VIEW_MODES } from '../constants';

const EventsGroup = ({ specId, events, snapshotsId, viewMode }) => {
  const isGroup = events.length > 1

  return (
    <>
      {isGroup && (
        <EventContainer
          key={specId}
          id={specId}
          name={events[0].tournamentSpecName}
          isSpec={true}
          viewMode={viewMode}
        />
      )}
      {events.map(({id, name, inProgress, adjusted}) => (
        <EventContainer
          key={snapshotsId[id] ?? id}
          id={snapshotsId[id] ?? id}
          name={name}
          inProgress={inProgress}
          adjusted={adjusted}
          isGroup={isGroup}
          viewMode={viewMode}
        />
      ))}
    </>
  )
}

EventsGroup.propTypes = {
  specId: PropTypes.string.isRequired,
  events: PropTypes.array.isRequired,
  snapshotsId: PropTypes.object,
  viewMode: PropTypes.oneOf(Object.values(VIEW_MODES)),
};

export default EventsGroup;